import { NgModule } from '@angular/core';
import { CouponCodeComponent } from './coupon-code.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [CouponCodeComponent],
    exports: [CouponCodeComponent],
    imports: [FormsModule, ReactiveFormsModule, CommonModule, TranslateModule],
    providers: []
})
export class CouponCodeModule {}
